import * as React from 'react';
import { Canceler } from 'axios';

const { useState, useEffect } = React;

interface IProps {
  forceReload?: string;
  margins?: string;
}
export const simplePage = (API_ENDPOINT: {
  getData: () => Promise<string>;
  cancel: Canceler;
}) => ({ forceReload, margins = 'mt-16 mb-24' }: IProps) => {
  const [loading, setLoading] = useState(false);
  const [content, setContent] = useState('');

  useEffect(() => {
    const { getData, cancel } = API_ENDPOINT;
    let fetching = true;
    async function fetch() {
      setLoading(true);
      setContent(await getData());
      setLoading(false);
      fetching = false;
    }
    fetch();
    return () => {
      if (fetching) {
        cancel();
      }
    };
  }, [forceReload]);

  return loading ? (
    <div className="loader max-w-md mx-auto bg-grey rounded mb-10 min-h-screen" />
  ) : (
    <div
      className={`content leading-normal max-w-md mx-auto ${margins}`}
      dangerouslySetInnerHTML={{ __html: content }}
    />
  );
};



// WEBPACK FOOTER //
// ./src/views/simplePage.tsx